import * as React from 'react';
import { SegmentedControl } from '../../components/SegmentedControl/index.ts';

const options = [
  { value: "all", label: "All" },
  { value: "cashierFraud", label: "Cashier Fraud" },
  { value: "cashierSuspicious", label: "Cashier Suspicious" },
];

export default function RadioButtonCashierSection({ category, setSelectedCategory, setCurrentCount, setIsAllDataFetched }: any) {

  const handleChange = (newValue: string) => {
    setSelectedCategory(newValue);
    setIsAllDataFetched(false);
    setCurrentCount(10);
  };

  return (
    <SegmentedControl
      options={options}
      value={category}
      onChange={handleChange}
    />
  );
}
